class VariantChange extends HTMLElement {
  constructor() {
    super();
    const _this = this;
    this.radioButons = this.querySelectorAll('input[type="radio"]');
    if (this.radioButons) {
      this.radioButons.forEach(function (input) {
        input.addEventListener("change", _this.ChangeVariant.bind(_this));
      });
    }
  }
  ChangeVariant() {
    this.GetOptions();
    this.GetVariantId();
    this.UpdateUrl();
    this.UpdateContent();
  }
  GetOptions() {
    /* options change*/
    const fieldsets = Array.from(
      this.querySelectorAll("[data-product-options-group]")
    );
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
  GetVariantId() {
    const variantJson = JSON.parse(
      this.querySelector('[type="application/json"]').textContent
    );
    /* options change*/
    this.currentVariant = variantJson.find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }
  UpdateUrl() {
    if (!this.currentVariant) return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }
  UpdateContent() {
    if (!this.currentVariant) {
      if (this.closest("product-form").querySelector('button[name="add"]')) {
        // this.closest("product-form")
        //   .querySelector('button[name="add"]')
        //   .setAttribute("disabled", "disabled");
        this.closest("product-form").querySelector(
          'button[name="add"]'
        ).innerHTML = window.translation.add_to_waitlist;
      }
      return;
    }
    this.closest("product-form")
      .querySelector("form")
      .querySelector('input[name="id"]').value = this.currentVariant.id;
    document
      .querySelector(".js-product product-form")
      .querySelector('button[name="add"]')
      .classList.add("loading");
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => {
        return response.text();
      })
      .then((response_html) => {
        const html = new DOMParser().parseFromString(
          response_html,
          "text/html"
        );
        const fetchPrice = html.querySelector("[data-product-price]");
        const fetchSku = html.querySelector("[data-product-sku]");
        const fetchButton = html.querySelector("[data-product-button]");
        const fetchNotification = html.querySelector(
          "[data-product-notification]"
        );
        const price = document.querySelector("[data-product-price]");
        const sku = document.querySelector("[data-product-sku]");
        const button = document.querySelector("[data-product-button]");
        const notification = document.querySelector(
          "[data-product-notification]"
        );
        if (fetchPrice && price) {
          price.innerHTML = fetchPrice.innerHTML;
        }
        if (fetchSku && sku) {
          sku.innerHTML = fetchSku.innerHTML;
        }
        if (fetchButton && button) {
          button.outerHTML = fetchButton.outerHTML;
        }
        if (fetchNotification && notification) {
          notification.innerHTML = fetchNotification.innerHTML;
        }
        // convertCurrency();
      })
      .catch((e) => {
        console.error(e);
      });
  }
}
customElements.define("product-option", VariantChange);
